import React from 'react';
import PropTypes from 'prop-types';

import { ColorSchema, colorSchemaList, ComponentSize, componentSizeList } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { MatchStatusType, MatchStatusList } from '../../../typings/match';
import { getMatchState } from '../../../utils/match-status';
import { makeClassNames, IClassNames, applyColorSchema } from '../../../utils/styles';

import './result-label.scss';

export interface IResultLabel extends IComponent {
  itemState: MatchStatusType;
}

const classNames = (colorSchema: ColorSchema, size?: ComponentSize): IClassNames =>
  makeClassNames({
    resultLabel: ['result-label', `${applyColorSchema('result-label', colorSchema)}`, size && `result-label--${size}`],
  });

const ResultLabel: React.FC<IResultLabel> = ({ itemState, children = '0-0', colorSchema = 'light', size }) => {
  const dataState = getMatchState(itemState);
  const cn = classNames(colorSchema, size);

  return (
    <span className={cn.resultLabel} data-state={dataState} data-size={size}>
      {children}
    </span>
  );
};

/* istanbul ignore else */ if (process.env.NODE_ENV !== 'production') {
  ResultLabel.propTypes = {
    children: PropTypes.node,
    colorSchema: PropTypes.oneOf(colorSchemaList),
    itemState: PropTypes.oneOf<MatchStatusType>(MatchStatusList).isRequired,
    size: PropTypes.oneOf(componentSizeList),
  };
}

export default ResultLabel;
